/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BatchTransfer, BatchTransferInterface } from "../BatchTransfer";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_messageBus",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "messageBus",
        type: "address",
      },
    ],
    name: "MessageBusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_dstChainId",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "_maxSlippage",
        type: "uint32",
      },
      {
        internalType: "enum MsgDataTypes.BridgeSendType",
        name: "_bridgeSendType",
        type: "uint8",
      },
      {
        internalType: "address[]",
        name: "_accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "batchTransfer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessage",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessageWithTransfer",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessageWithTransferFallback",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessageWithTransferRefund",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "messageBus",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_messageBus",
        type: "address",
      },
    ],
    name: "setMessageBus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    name: "status",
    outputs: [
      {
        internalType: "bytes32",
        name: "h",
        type: "bytes32",
      },
      {
        internalType: "enum BatchTransfer.TransferStatus",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type BatchTransferConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: BatchTransferConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class BatchTransfer__factory extends ContractFactory {
  constructor(...args: BatchTransferConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BatchTransfer";
  }

  deploy(_messageBus: string, overrides?: Overrides & { from?: string | Promise<string> }): Promise<BatchTransfer> {
    return super.deploy(_messageBus, overrides || {}) as Promise<BatchTransfer>;
  }
  getDeployTransaction(
    _messageBus: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_messageBus, overrides || {});
  }
  attach(address: string): BatchTransfer {
    return super.attach(address) as BatchTransfer;
  }
  connect(signer: Signer): BatchTransfer__factory {
    return super.connect(signer) as BatchTransfer__factory;
  }
  static readonly contractName: "BatchTransfer";
  public readonly contractName: "BatchTransfer";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BatchTransferInterface {
    return new utils.Interface(_abi) as BatchTransferInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): BatchTransfer {
    return new Contract(address, _abi, signerOrProvider) as BatchTransfer;
  }
}
